"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyInsightMenuButton = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var util_1 = require("@gooddata/util");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../../../model");
var nonExportableVisTypes = ["headline", "xirr"];
function isExportableVisualization(visType) {
    return !nonExportableVisTypes.includes(visType);
}
var bubbleAlignPoints = [{ align: "tc bc" }, { align: "tc br" }];
exports.LegacyInsightMenuButton = function (_a) {
    var onClick = _a.onClick, widget = _a.widget, insight = _a.insight, isOpen = _a.isOpen;
    var intl = react_intl_1.useIntl();
    var onOptionsMenuClick = react_1.useCallback(function () {
        onClick();
    }, [onClick]);
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var canExportTabular = model_1.useDashboardSelector(model_1.selectCanExportTabular);
    var areExportsEnabled = settings.enableKPIDashboardExport;
    var hasExportReportPermissions = canExportTabular;
    var visType = sdk_model_1.insightVisualizationUrl(insight).split(":")[1];
    var isExportableVisType = isExportableVisualization(visType);
    var canExportWidget = areExportsEnabled && hasExportReportPermissions && isExportableVisType;
    if (!canExportWidget) {
        return null;
    }
    var widgetRefValue = sdk_model_1.widgetRef(widget);
    var objRefAsString = widgetRefValue ? sdk_model_1.objRefToString(widgetRefValue) : "";
    var optionsIconClasses = classnames_1.default("dash-item-action-options", "s-dash-item-action-options", "dash-item-action-options-" + util_1.stringUtils.simplifyText(objRefAsString), "s-dash-item-action-options-" + util_1.stringUtils.simplifyText(objRefAsString), "gd-icon-download", {
        "dash-item-action-options-active": isOpen,
    });
    return (react_1.default.createElement("div", { className: "dash-item-action-placeholder s-dash-item-action-placeholder", onClick: onOptionsMenuClick },
        react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { className: optionsIconClasses, showDelay: 500, hideDelay: 0, tagName: "div" },
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: bubbleAlignPoints },
                react_1.default.createElement("span", null, intl.formatMessage({ id: "options.button.bubble" }))))));
};
//# sourceMappingURL=LegacyInsightMenuButton.js.map